/**
 * M 端 header 搜索交互（X 站 UI 改版）
 * 默认态：header 左侧只展示搜索图标；点击后 header 切换为「返回箭头 + 搜索输入框」，
 * 页面内容加遮罩，联想结果以全宽白色面板展示在 header 下方。
 * 仅 <=768px 生效，PC 端不受影响。
 */
(function () {
  function init() {
    var header = document.querySelector('.section-header .header.inline-header-search');
    if (!header) return;

    var wrapper = header.closest('.header-wrapper');
    var toggle = header.querySelector('.header__mobile-search-toggle');
    var back = header.querySelector('.header__mobile-search-back');
    var overlay = wrapper ? wrapper.querySelector('.header__mobile-search-overlay') : null;
    var searchComponent = header.querySelector('.header__search predictive-search');
    if (!toggle || !back || !searchComponent) return;

    var input = searchComponent.querySelector('input[type="search"]');
    if (!input) return;

    var mql = window.matchMedia('(max-width: 768px)');

    function setPanelTop() {
      // 联想面板/遮罩从 header 下边缘开始（含公告栏等 sticky 偏移）
      var rect = header.getBoundingClientRect();
      document.documentElement.style.setProperty('--mobile-search-top', rect.bottom + 'px');
    }

    function isOpen() {
      return header.classList.contains('mobile-search-open');
    }

    function open() {
      if (!mql.matches || isOpen()) return;
      if (toggle.dataset.mobilePlaceholder) {
        input.setAttribute('placeholder', toggle.dataset.mobilePlaceholder);
      }
      setPanelTop();
      header.classList.add('mobile-search-open');
      if (wrapper) wrapper.classList.add('mobile-search-open');
      document.body.classList.add('overflow-hidden');
      // 同步 focus：保持在用户手势上下文内，iOS 才能自动弹出键盘
      input.focus();
    }

    function close() {
      if (!isOpen()) return;
      // 清空关键词并关闭联想结果
      if (typeof searchComponent.close === 'function') {
        searchComponent.close(true);
      }
      header.classList.remove('mobile-search-open');
      if (wrapper) wrapper.classList.remove('mobile-search-open');
      document.body.classList.remove('overflow-hidden');
      input.blur();
    }

    toggle.addEventListener('click', open);
    back.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });
    // 切换到 PC 宽度时强制关闭，避免影响 PC header
    mql.addEventListener('change', function (event) {
      if (!event.matches) close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
